import React, { useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Grid,
  IconButton,
  useTheme,
  alpha,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { LanguageContext } from "../../../../context/LanguageContext";

const StrategyParameterDialog = ({ open, onClose, parameters }) => {
  const theme = useTheme();
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("StrategyParameterDialog", "strategy/StrategyParameterDialog/StrategyParameterDialog_lang");
  }, [language, loadLanguageFile]);

  const LANGUAGE = componentLanguageData.StrategyParameterDialog || { Main: {} };

  const fieldMap = [
    { key: "symbol", label: LANGUAGE.Main.Content1},
    { key: "timeframe", label: LANGUAGE.Main.Content2 },
    { key: "capital", label: LANGUAGE.Main.Content3 },
    { key: "lotSize", label: LANGUAGE.Main.Content4 },
    { key: "startYear", label: LANGUAGE.Main.Content5 },
    { key: "ordertype", label: LANGUAGE.Main.Content6 },
    { key: "endYear", label: LANGUAGE.Main.Content7 },
    { key: "entryCondition", label: LANGUAGE.Main.Content8, fullWidth: true },
    { key: "exitCondition", label: LANGUAGE.Main.Content9, fullWidth: true },
    { key: "description", label: LANGUAGE.Main.Content10, fullWidth: true },
  ];

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
        }
      }}
    >
      <DialogTitle sx={{ 
        fontWeight: 700, 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        pb: 1
      }}>
        {LANGUAGE.Main.Content11}
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{ 
            color: theme.palette.grey[500],
            "&:hover": { color: theme.palette.grey[700], bgcolor: alpha(theme.palette.grey[500], 0.1) }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {fieldMap.map((field) => (
            <Grid item xs={12} sm={field.fullWidth ? 12 : 6} key={field.key}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.primary.main, 0.03),
                  border: "1px solid",
                  borderColor: alpha(theme.palette.divider, 0.5),
                  height: "100%",
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={600}
                  textTransform="uppercase"
                  letterSpacing={0.5}
                  mb={0.5}
                >
                  {field.label || field.key}
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                  sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
                >
                  {parameters?.[field.key] || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

StrategyParameterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  parameters: PropTypes.object,
};

export default StrategyParameterDialog;
